module.exports = __webpack_public_path__ + "img/notif-clock.c593d71c.svg";